import { Controller } from '@hotwired/stimulus';
import { post } from '@rails/request.js';
import CurrentPage from '@frontend/app/features/CurrentPage';
import { dispatchCustomEvent } from '@frontend/utils/events';

export default class extends Controller {
  connect() {
    document.body.addEventListener(
      'track-metrics-action:track',
      this.handleTrack.bind(this)
    );
  }

  track({ params: { name, options } }) {
    this.trackAction(name, options);
  }

  handleTrack(event) {
    const name = event.detail.name;
    const options = event.detail.options;

    this.trackAction(name, options);
  }

  trackAction(name, options = {}) {
    const body = JSON.stringify({
      metrics_action: { name: name, options: options },
    });
    post(CurrentPage.getTrackMetricsActionPath(), { body: body });
  }
}

export function trackAction(name, options = {}) {
  dispatchCustomEvent('track-metrics-action:track', { name, options });
}
